import { render, staticRenderFns } from "./YsfBank.vue?vue&type=template&id=508c94f6"
import script from "./YsfBank.vue?vue&type=script&lang=js"
export * from "./YsfBank.vue?vue&type=script&lang=js"
import style0 from "./YsfBank.vue?vue&type=style&index=0&id=508c94f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports